import * as documentsTypes from './documentsTypes';


const initialState = {
  documentIds: [],
  getsupportFileType: {
    fileSupport: [],
  },
  getIRCounter : {
    IRCounter: [],
  },
  documentIdsFailure: false,
  documentDetail: {},
  documentDetailFailure: false,
  documents: [],
  showFilterModal: false,
  filters: {},
  tableData: [],
  clients: [],
  documentTypes: [],
  documentIdList: [],
  employees: [],
  documentFields: [],
  showToastMessage: false,
  toastMessage: '',
  activeCaseManagerId: null,
  openDocumentsTab: false,
  caseDetailsDocCount: null,
  documentSlaDetail: {},
  documentSLAList:[],
  isUploadError: false,
  getDeletedFile:[],
  docUploadSeviceSpinner:false,
  docSubmitSeviceSpinner:false,
  taxReturnDocTypeId: 0,
};

const documentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case documentsTypes.GET_DOCUMENTS_SUCCESS: {
      return { ...state, tableData: action.payload };
    }
    case documentsTypes.GET_LINKEDCASE_SUCCESS:{
      return {
        ...state,
        linkedCases: action.payload
      };
    }
    case documentsTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl,
      };
    case documentsTypes.HYDRATE_DOCUMENTS_FILTERS:
      return {
        ...state,
        filters: action.filters,
      };
      case documentsTypes.GET_SUPPORT_FILE:
        return {
          ...state,
          getsupportFileType: action.payload,
        };
      case documentsTypes.GET_IR_COUNTER:
       return {
            ...state,
            getIRCounter: action.payload,
          };
   case documentsTypes.RESET_DELETEDFILE:
        return {
          ...state,
          getDeletedFile:[],
          isUploadError:false
        }; 
    case documentsTypes.GET_CLIENTS_SUCCESS:
      return { ...state, clients: action.data };
    case documentsTypes.GET_DOCUMENT_TYPES_SUCCESS: {
      const documentTypes = state.documentTypes.slice();
      const taxReturnDocTypeId = action.data.taxReturnDocTypeId;
      documentTypes[action.index] = action.data.documenTypes;
      return { ...state, documentTypes, taxReturnDocTypeId };
    }
    case documentsTypes.GET_EMPLOYEES_SUCCESS: {
      const employees = state.employees.slice();

      employees[action.index] = action.data;

      return { ...state, employees };
    }
    case documentsTypes.RESET_DOCUMENT_UPLOAD:
      return { ...state, clients: [], documentTypes: [], documentIds: [], employees: [], documentFields: [] };
    case documentsTypes.RESET_DOCUMENT_FIELDS:
      const documentFields = state.documentFields.slice();

      documentFields[action.index] = null;

      return { ...state, documentFields };
    case documentsTypes.GET_REJECTED_FILE_FAILURE:
         return {...state,
          isUploadError: true,
          getDeletedFile: state.getDeletedFile.concat(action.file)
          };
    case documentsTypes.HYDRATE_DOCUMENT_DETAILS:
      return {
        ...state,
        documentDetail: action.payload,
      };
    case documentsTypes.DEHYDRATE_DOCUMENT_DETAILS:
      return {
        ...state,
        documentDetail: {},
      };
    case documentsTypes.GET_DOCUMENT_FIELDS_SUCCESS: {
      const documentFields = state.documentFields.slice();

      documentFields[action.index] = action.data;

      return { ...state, documentFields };
    }
    case documentsTypes.HYDRATE_DOCUMENTS:
      return {
        ...state,
        documents: action.payload,
      };
    case documentsTypes.SHOW_DELETE_NOTIFICATION_SUCCESS:
      return { ...state, showToastMessage: true, toastMessage: action.message };
    case documentsTypes.HIDE_DELETE_NOTIFICATION_SUCCESS:
      return { ...state, showToastMessage: false };
    case documentsTypes.REFRESH_DOCUMENT_STATE:
      return {
        ...state,
        tableData: action.filteredDocs,
      };
    case documentsTypes.SET_DOCUMENT_ID: {
      const documentIds = state.documentIds.slice();

      documentIds.push(action.data);

      return { ...state, documentIds,isUploadError: false };
    }
    case documentsTypes.APPLIED_DOCUMENTS_FILTERS: {
      return {
        ...state,
        appliedFilters: action.filters ? action.filters : undefined,
      };
    }
    case documentsTypes.STORE_CASEMANAGER_ID: {
      return {
        ...state,
        activeCaseManagerId: action.payload,
      };
    }
    case documentsTypes.OPEN_DOCS_TAB: {
      return {
        ...state,
        openDocumentsTab: action.payload,
      };
    }
    case documentsTypes.INCREMENT_DOC_COUNT: {
      return {
        ...state,
        caseDetailsDocCount: action.payload,
      };
    }
    case documentsTypes.UPDATE_UPLOAD_STATUS: {
      let caseDocumentsNew = state.tableData.caseDocuments.slice();
      let index= action.origRowIndex;
      caseDocumentsNew[index].uploadStatus = action.uploadStatus;
      return {
        ...state,
        tableData: { ...state.tableData, caseDocuments: caseDocumentsNew },
      };
    }
    case documentsTypes.MARK_DOCUMENT_READ: {
      let caseDocumentsNew = state.tableData.caseDocuments.slice();
      let index= action.origRowIndex;
      caseDocumentsNew[index].markReceived = action.isChecked;
      return {
        ...state,
        tableData: { ...state.tableData, caseDocuments: caseDocumentsNew },
      };
    }
    case documentsTypes.ACKNOWLEDGE_DOCUMENT_READ: {
      let caseDocumentsAcknowledge = state.tableData.caseDocuments.slice();
      let index= action.origRowIndex;
      caseDocumentsAcknowledge[index].acknowledge = action.isChecked;
      return {
        ...state,
        tableData: { ...state.tableData, caseDocuments: caseDocumentsAcknowledge },
      };
    }
    case documentsTypes.GET_SLA_DOCUMENT_DETAILS: {
      return {
        ...state,
        documentSlaDetail:{ ...action.data}
      }
    }
    case documentsTypes.GET_SLA_LIST: {
      return {
        ...state,
        documentSLAList: [...action.data]
      }
    }
    case documentsTypes.ENABLE_SERVICE_SPINNER: {
      return  {
        ...state,
        docUploadSeviceSpinner: true,
      }
    }
    case documentsTypes.DISABLE_SERVICE_SPINNER: {
      return  {
        ...state,
        docUploadSeviceSpinner: false,
      }
    }
    case documentsTypes.ENABLE_DOC_SUBMIT_SERVICE_SPINNER: {
      return  {
        ...state,
        docSubmitSeviceSpinner: true,
      }
    }
    case documentsTypes.DISABLE_DOC_SUBMIT_SERVICE_SPINNER: {
      return  {
        ...state,
        docSubmitSeviceSpinner: false,
      }
    }
    case documentsTypes.DELETE_UPLOADED_DOCUMENT:
        let documentIds = state.documentIds.slice();
        for (let i = documentIds.length; i--;) {
            if(documentIds[i].name === action.docName){
                documentIds.splice(i, 1, null);
            }
        }
        documentIds = documentIds.filter(elem => elem);
        const newState = { ...state, documentIds }
        return newState;
    default: {
      return state;
    }
  }
};

export { initialState };
export default documentsReducer;



// WEBPACK FOOTER //
// ./src/ui/features/Documents/state/documentsReducer.js